import View from "./view.js";
import PreviewView from "./previewview.js";
import icons from 'url:../../img/icons.svg';


class ResultsView extends View {
    _parentElement = document.querySelector(`.results`);
    _errorMessage = `NO RECIPE FOUND FOR YOUR QUERY, PLEASE TRY ANOTHER ONE`;
    _message = ``;

    _generateMarkup() {
        return this._data
            .map(result => PreviewView.render(result, false))
            .join(``);
    }
}

export default new ResultsView();